import type { ReactNode } from 'react';
import {
  ChatIcon,
  ChevronDownIcon,
  PoweroffIcon,
  SwapIcon,
} from 'tdesign-icons-react';
import { handleLogout, showChangeTeamModal } from '@ssv-website/hooks';
import { LinkHref } from '../../navbar/config';
import {
  getConferenceChatAuthApiBySite,
  openConferenceChatEntry,
} from '../../navbar/conferenceChat';
import { UserCircleIcon } from '../s-2026-signup/icons';

export function FieldLabel({
  text,
  required = false,
}: {
  text: string;
  required?: boolean;
}) {
  return (
    <span className="signup-2026-field-label block text-sm leading-[22px] text-[#121212]">
      {text}
      {required ? <span className="ml-1 text-[#E34D59]">*</span> : null}
    </span>
  );
}

export function MeetingInfo({
  className,
  icon,
  children,
}: {
  className?: string;
  icon: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className={`inline-flex items-center gap-1 ${className ?? ''}`}>
      <span className="shrink-0">{icon}</span>
      <span>{children}</span>
    </div>
  );
}

export function MeetingUserDropdown({
  displayedAccount,
  hasTeam,
  teamType,
}: {
  displayedAccount: string;
  hasTeam: boolean;
  teamType?: number;
}) {
  const goAccount = () => {
    const url = teamType === 2 ? LinkHref.TeamAccount : LinkHref.Account;
    window.location.href = url;
  };

  const actions = [
    // {
    //   label: 'Account Center',
    //   icon: <UserIcon size={16} />,
    //   onClick: goAccount,
    // },
    ...(teamType === 2 || hasTeam
      ? [
          {
            label: 'Switch Team',
            icon: <SwapIcon size={16} />,
            onClick: () =>
              showChangeTeamModal({ isLogin: false, closeBtn: true }),
          },
        ]
      : []),
    {
      label: 'Chat',
      icon: <ChatIcon size={16} />,
      onClick: () => {
        // 英文报名页会聊入口始终展示；是否可进入统一由海外 BFF 鉴权接口决定。
        void openConferenceChatEntry({
          authApi: getConferenceChatAuthApiBySite('en'),
          site: 'en',
        });
      },
    },
    {
      label: 'Log Out',
      icon: <PoweroffIcon size={16} />,
      onClick: handleLogout,
    },
  ];

  return (
    <div className="group relative">
      <div className="cursor-pointer overflow-hidden rounded-[4px] group-hover:overflow-visible">
        <div className="inline-flex items-center gap-2 rounded-[4px] px-[6px] py-[5px] text-[rgba(0,0,0,0.9)] transition-colors duration-200 group-hover:bg-[#F3F5F7]">
          <UserCircleIcon />
          <span className="max-w-[120px] truncate text-sm leading-[22px]">
            {displayedAccount || '--'}
          </span>
          <ChevronDownIcon size={16} />
        </div>
      </div>
      <div className="pointer-events-none absolute right-0 top-full z-20 pt-3 opacity-0 transition-all duration-200 group-hover:pointer-events-auto group-hover:opacity-100">
        <div className="min-w-[154px] rounded-[8px] bg-white py-4 shadow-card">
          {actions.map((action) => (
            <div
              key={action.label}
              className="signup-2026-user-menu-item relative flex cursor-pointer items-center gap-2 px-5 py-2 text-left text-sm leading-6 text-[#121212] transition-colors duration-200 hover:text-[#0052D9]"
              onClick={action.onClick}
            >
              {action.icon}
              <span>{action.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
